import { getEditProviderEndpoint, methods } from '../../utils/apiHelper'
import { apiCall } from '../../utils/restclient'
import {
  DELETE_MEMBER,
  DELETE_MEMBER_ERROR,
  DELETE_MEMBER_SUCCESS,
  GET_MEMBER,
  GET_MEMBER_ERROR,
  GET_MEMBER_SUCCESS,
  GET_SERVICE_TYPES,
  GET_SERVICE_TYPES_ERROR,
  GET_SERVICE_TYPES_SUCCESS_MEMBER,
  OVERWRITE_MEMBER_PRODUCTIVITY,
  OVERWRITE_MEMBER_PRODUCTIVITY_ERROR,
  OVERWRITE_MEMBER_PRODUCTIVITY_SUCCESS,
  RESEND_INVITE,
  RESEND_INVITE_ERROR,
  RESEND_INVITE_SUCCESS,
  SET_MEMBER_ACTIVATION,
  SET_MEMBER_ACTIVATION_ERROR,
  SET_MEMBER_ACTIVATION_SUCCESS,
  SET_PHONE_VALIDATION,
  VALIDATE_PHONE_NUMBER,
  VALIDATE_PHONE_NUMBER_ERROR,
  VALIDATE_PHONE_NUMBER_SUCCESS,
} from './MemberConstants'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const deleteMember = (id, type) => {
  const endpoint = type === 'Admin' ? `api/v1/admins/${id}` : `api/v1/providers/${id}`
  const action = {
    type: DELETE_MEMBER,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'DELETE', null, null, {
      success: DELETE_MEMBER_SUCCESS,
      error: DELETE_MEMBER_ERROR,
      extraData: { UserType: type },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function validatePhoneNumber(number, UserId) {
  const endpoint = `api/v1/utilities/validatephonenumber`
  const extraData = { UserId }
  const action = {
    type: VALIDATE_PHONE_NUMBER,
    extraData,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'POST', null, JSON.stringify(number), {
      success: VALIDATE_PHONE_NUMBER_SUCCESS,
      error: VALIDATE_PHONE_NUMBER_ERROR,
      extraData,
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setPhoneValidation = (value, UserId) => ({
  type: SET_PHONE_VALIDATION,
  payload: { value, UserId },
})
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getMember = (id, type, visitId) => {
  const endpoint = type === 'Admin' ? `api/v1/admins/${id}` : getEditProviderEndpoint(id)
  const action = {
    type: GET_MEMBER,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, methods.GET, null, null, {
      success: GET_MEMBER_SUCCESS,
      error: GET_MEMBER_ERROR,
      extraData: { UserType: type, memberId: id, visitId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}
export const getServiceTypes = () => {
  const endpoint = 'api/v1/servicetypes'
  const action = {
    type: GET_SERVICE_TYPES,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_SERVICE_TYPES_SUCCESS_MEMBER,
      error: GET_SERVICE_TYPES_ERROR,
    })
    return action
  } catch (e) {
    console.log(e)
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const resendInvite = (id, type) => {
  const endpoint =
    type === 'Admin' ? `api/v1/admins/${id}/resendverificationemail` : `api/v1/providers/${id}/resendverificationemail`
  const action = {
    type: RESEND_INVITE,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'POST', null, null, {
      success: RESEND_INVITE_SUCCESS,
      error: RESEND_INVITE_ERROR,
      extraData: { UserType: type },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setMemberActivation = (UserId, willActivate, type) => {
  const endpoint = `api/v1/${type === 'Admin' ? 'admins' : 'providers'}/${UserId}/${
    willActivate ? 'activate' : 'deactivate'
  }`
  const extraData = { UserId, willActivate }
  const action = {
    type: SET_MEMBER_ACTIVATION,
    extraData,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'PUT', null, null, {
      success: SET_MEMBER_ACTIVATION_SUCCESS,
      error: SET_MEMBER_ACTIVATION_ERROR,
      extraData,
    })
    return action
  } catch (e) {
    console.log(e)
  }
}
// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const overwriteMemberProductivity = ({ userId, requestBody }) => {
  const endpoint = `api/v1/providers/${userId}/productivityoverrides`
  const action = {
    type: OVERWRITE_MEMBER_PRODUCTIVITY,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'PUT', null, JSON.stringify({ ...requestBody }), {
      success: OVERWRITE_MEMBER_PRODUCTIVITY_SUCCESS,
      error: OVERWRITE_MEMBER_PRODUCTIVITY_ERROR,
      extraData: { userId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}
